import {isUndefined, range} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {palette} from '../../../../libs/shared/ui/src/styles/colorStyles';

/*
 * Props.
 */

export interface SurveyStarsInputProps {
  setScore(score: number): void;
  score?: number;
}

/*
 * Style.
 */

const StyledStarContainerDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin: 27px auto 20px auto;
`;

/*
 * Types.
 */

enum IconNamesEnum {
  STAR = 'star',
  STAR_FILLED = 'starFilled',
}

/*
 * Component.
 */

export const SurveyStarsInput: FC<SurveyStarsInputProps> = ({setScore, score}) => {
  const starsCount = 5;
  return (
    <StyledStarContainerDiv>
      {range(1, 1 + starsCount).map((value) => {
        const isFilled = !isUndefined(score) && score >= value;
        const iconName = isFilled ? IconNamesEnum.STAR_FILLED : IconNamesEnum.STAR;
        const color = isFilled ? computeStarShade(score) : palette.grey.shade30;
        return (
          <IconButton
            iconName={iconName}
            label={`Rate ${value} stars`}
            color={color}
            onClick={() => setScore(value)}
            key={`star-${value}`}
          />
        );
      })}
    </StyledStarContainerDiv>
  );
};

/*
 * Helpers.
 */

function computeStarShade(score?: number): string {
  switch (score) {
    case 5:
      return palette.blue.shade50;
    case 4:
      return palette.blue.shade40;
    case 3:
      return palette.blue.shade30;
    case 2:
      return palette.blue.shade20;
    default:
      return palette.blue.shade10;
  }
}
